export default __webpack_public_path__ + "static/media/Flip_Default.bacb06c7.png";